(() => {
  const prefill = () => {
    const raw = new URL(window.location.href).searchParams.get('fm_search');
    if (!raw) return;
    const terms = raw.trim().slice(0, 500);
    if (!terms) return;
    document.querySelectorAll('textarea[name="contact[body]"][data-fm-search-prefix]').forEach((field) => {
      if (field.value.trim()) return;
      field.value = field.dataset.fmSearchPrefix + ' ' + terms;
      field.dispatchEvent(new Event('input', { bubbles: true }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill, { once: true });
  else prefill();
  document.addEventListener('shopify:section:load', prefill);
})();
